import Vue from 'vue'
// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cursor = 'move'
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
    dialogHeaderEl.onmousedown = (e) => {
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop
      let styL, styT
      if (sty.left.includes('%')) {
        styL = document.body.clientWidth * parseFloat(sty.left) / 100
        styT = document.body.clientHeight * parseFloat(sty.top) / 100
      } else {
        styL = parseFloat(sty.left)
        styT = parseFloat(sty.top)
      }
      document.onmousemove = (e) => {
        dragDom.style.left = `${e.clientX - disX + styL}px`
        dragDom.style.top = `${e.clientY - disY + styT}px`
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
